document.addEventListener('DOMContentLoaded', function () {
  // ===== PC 滚动控制（修复版）=====
  const pcContainer = document.getElementById('scrollPageSwichImg');
  const pcSlides = document.querySelectorAll('#scrollPageSwichImg .pc-slide');

  if (!pcContainer || pcSlides.length === 0) return;

  let currentSlide = 0;
  let isAnimating = false;

  function goToSlide(index) {
    if (isAnimating || index < 0 || index >= pcSlides.length) return;

    isAnimating = true;

    pcSlides.forEach((slide, i) => {
      slide.classList.toggle('active', i === index);
    });

    currentSlide = index;

    setTimeout(() => {
      isAnimating = false;
    }, 100);
  }

  // ✅ 是否允许接管滚动（核心控制）
  function canInteract() {
    const rect = pcContainer.getBoundingClientRect();

    const topThreshold = 100;     // 顶部容差（防止刚露出就触发）
    const bottomThreshold = 100;  // 底部容差

    return (
      rect.top <= topThreshold &&
      rect.bottom >= window.innerHeight - bottomThreshold
    );
  }

  // ✅ 强制吸附到顶部（防止滚过头）
  function fixToTop() {
    const rect = pcContainer.getBoundingClientRect();

    if (rect.top < 0) {
      window.scrollTo({
        top: window.scrollY + rect.top,
        behavior: 'instant'
      });
    }
  }

  // ✅ 用 window 监听（更稳定，避免鼠标位置影响）
  window.addEventListener('wheel', (e) => {
    // ❗不在交互区 → 不处理
    if (!canInteract()) return;

    // ❗防止惯性滚过头
    fixToTop();

    if (isAnimating) {
      e.preventDefault();
      return;
    }

    const deltaY = e.deltaY;

    // ===== 向下 =====
    if (deltaY > 0) {
      if (currentSlide < pcSlides.length - 1) {
        e.preventDefault();
        goToSlide(currentSlide + 1);
      }
      // 最后一屏 → 放行
      return;
    }

    // ===== 向上 =====
    if (deltaY < 0) {
      if (currentSlide > 0) {
        e.preventDefault();
        goToSlide(currentSlide - 1);
      }
      // 第一屏 → 放行
      return;
    }

  }, { passive: false });

  // Mobile Logic
  const mobileSlider = document.getElementById('mobileSlider');
  const prevBtn = document.getElementById('prevBtn');
  const nextBtn = document.getElementById('nextBtn');
  let mobileIndex = 0;
  const totalMobile = document.querySelectorAll('.mobile-slide').length;

  function updateMobileSlider() {
    mobileSlider.style.transform = `translateX(-${mobileIndex * 100}%)`;
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      if (mobileIndex < totalMobile - 1) {
        mobileIndex++;
        updateMobileSlider();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      if (mobileIndex > 0) {
        mobileIndex--;
        updateMobileSlider();
      }
    });
  }

  // Touch swipe
  let startX = 0;
  mobileSlider?.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
  });

  mobileSlider?.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    const diff = startX - endX;
    if (Math.abs(diff) > 50) {
      if (diff > 0 && mobileIndex < totalMobile - 1) {
        mobileIndex++;
      } else if (diff < 0 && mobileIndex > 0) {
        mobileIndex--;
      }
      updateMobileSlider();
    }
  });
});